import { isFunction } from 'lodash';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Typography, Colors, FormLabel, Spacer } from '@zapier/design-system';
import { Checkbox as DSCheckbox } from '@zapier/design-system-beta';
const Styles = {
    details: Object.assign(Object.assign({}, Typography.smallPrint1), { lineHeight: 1.5, color: Colors.neutral700, margin: '5px 0 10px 0', display: 'flex', 
        // Override problematic default browser styles.
        'ol, ul': {
            listStylePosition: 'inside',
            margin: 0,
            padding: 0,
        } }),
};
/**
 * A checkbox form field with optional tooltip and instructions.
 */
const Checkbox = ({ onChange, staticProperties: { id, label, isVisible = true, isRequired = false, details, }, }) => {
    if (!isVisible) {
        return null;
    }
    const handleChange = (isSelected) => {
        onChange(isSelected.toString());
    };
    return (isolateComponent("div", null,
        isolateComponent(DSCheckbox, { defaultSelected: false, id: id, onChange: handleChange },
            isolateComponent(FormLabel, { htmlFor: id, isRequired: isRequired, size: "small" }, label)),
        !details && isolateComponent(Spacer, { height: 5 }),
        details && (isolateComponent("div", { css: Styles.details }, isFunction(details) ? details() : details))));
};
export default Checkbox;
